import { Box, makeStyles, Snackbar, Theme } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { snackbarState } from "../store/layout";

export function Alert(props: AlertProps) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2),
		},
	},
}));

export default function CustomizedSnackbars() {
	const classes = useStyles();
	const resetSnackbar = useResetRecoilState(snackbarState);
	const snackBar = useRecoilValue(snackbarState);

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		resetSnackbar();
	};

	return (
		<div className={classes.root}>
			<Snackbar
				anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
				open={snackBar.isOpen}
				autoHideDuration={snackBar.duration === undefined ? 3000 : snackBar.duration}
				onClose={handleClose}
			>
				<Alert onClose={handleClose} severity={snackBar.type} action={<Box display="flex">{snackBar.action}</Box>}>
					{snackBar.message}
				</Alert>
			</Snackbar>
		</div>
	);
}
